export const Styles = {
    contentBlock: {
        padding: '30px 45px 30px 30px',
    },
};
